import React, { useEffect, useContext } from 'react';
import { store } from '../reducer';
import { isMobile } from 'react-device-detect';
import Form from './Form';
import { useParams, useHistory } from 'react-router-dom';
import ListRules from './ListRules';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const AddOrEdit = () => {
  const classes = useStyles();
  const { dispatch, showMessage, showError } = useContext(store);
  const {
    location: {
      state: {
        category: { name: catName },
      },
    },
  } = useHistory();

  useEffect(() => {
    dispatch({
      type: 'CHANGE_TITLE_SUBTITLE',
      payload: {
        title: `مدیریت عملکردهای نقش: ${catName}`,
        subtitle:
          'جهت افزودن از فرم سمت چپ، جهت ویرایش بر روی نام دسترسی از لیست زیر کلیک کنید و جهت حذف بر روی آیکن حذف روبروی نامش کلیک کنید.',
      },
    });
  }, []);

  return (
    <div className={classes.root}>
      <ListRules />
      <Form />
    </div>
  );
};

export default React.memo(AddOrEdit);
